export default __webpack_public_path__ + "static/media/bg_login.ed611566.jpg";